<template>
  <div style="position:relative" class="link-box">
    <div class="edite-box">
      <el-popover placement="right" trigger="click" v-model="dialogVisible">
        <div class="add-time-dialog">
          <p>新增时间</p>
          <div>
            <span>{{ name }}：</span>
            <el-date-picker v-model="dateValue" style="width:210px!important" size="small" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </div>
          <div class="dialog-footer">
            <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitAddTime()" size="small">确 定</el-button>
          </div>
        </div>
        <div slot="reference" class="add-time" @click="addTime()">+新增时间</div>
      </el-popover>
      <div class="record" v-if="dateHistoryList.length && dateHistoryList.length > 1" @click="showRecord = !showRecord">历史记录
        <i class="icon-arrow el-icon-arrow-down" v-if="!showRecord"></i>
        <i class="icon-arrow el-icon-arrow-up" v-else></i>
      </div>
    </div>
    <div class="chain-list" :class="!showRecord ? 'chain-list-height' : ''" v-if="dateHistoryList.length > 0">
      <div class="chain-item" v-for="(item, index) in dateHistoryList" :key="index">
        <p>{{ item.dataValue }}</p>
        <div class="edite-record">
          <div class="chain-checked" v-if="item.axisName">已关联{{ item.axisName }}，</div>
          <RelateChain :eventName="eventName" :patientFilesId="patientFilesId" :chainTimeText="name"
            :chainDate="item.dataValue" :id='item.id' :axisName='item.axisName' :dateName='handelDateValue()'
            @toUpTime='toUpTime' />
          <span class="chain-edite" @click="addTime(item)">编辑</span>
          <span class="del-btn" @click="showDelDialog(item)">删除</span>
        </div>
      </div>
    </div>
    <div class="del-dialog" v-if="delDialog">
      <div class="del-con">
        <p class="tips-icon">!</p>
        <div>{{ tips }}</div>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" @click="onDelTime()">确 定</el-button>
        <el-button @click="delDialog = false">取 消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {addPatientDate, delPatientDate, upPatientDate} from "../../api";

export default {
  props: {
    eventName: {
      type: String,
      default: "病例信息"
    },
    patientFilesId: {
      type: String,
      default: "-2"
    },
    date: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    dateList: {}
  },
  watch: {
    dateList: {
      handler(val) {
        if (val && val.length) {
          this.dateHistoryList = val;
        } else {
          this.dateHistoryList = [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    RelateChain: () =>
      import("@/views/treatment/components/CrossReferenceEntry/RelateChain.vue")
  },
  data() {
    return {
      dialogVisible: false,
      delDialog: false,
      tips: "是否确认删除当前时间，删除后不可恢复",
      options: [],
      dateValue: "",
      showRecord: false,
      dateHistoryList: [],
      curEditeItem: "",
      editeStatus: false,
      timeList: [
        { name: "入院时间", value: "hospitalStaysTime" },
        { name: "手术时间", value: "operationTime" },
        { name: "出院时间", value: "hospitalDischargeTime" },
        { name: "孕前末次月经", value: "lastMenstrualPeriod" },
        { name: "其他治疗时间", value: "otherTreatmentTime" },
        { name: "随访时间", value: "followUpTime" },
        { name: "放疗时间", value: "radiotherapyTime" },
        { name: "化疗时间", value: "chemotherapyTime" },
        { name: "靶向治疗时间", value: "targetedTherapyTime" },
        { name: "内分泌治疗时间", value: "endocrineTherapyTime" },
        { name: "免疫抑制治疗时间", value: "immunosuppressiveTherapyTime" },
        { name: "姑息治疗时间", value: "palliativeTherapyTime" },
        { name: "诱导治疗时间", value: "inductionTherapyTime" },
        { name: "碘131治疗时间", value: "iodine131TherapyTime" },
        { name: "血液透析时间", value: "hemodialysisTime" },
        { name: "腹膜透析时间", value: "peritonealDialysisTime" },
        { name: "新辅助化疗时间", value: "newAssistChemotherapyTime" },
        { name: "新辅助放疗时间", value: "newAssistRadiotherapyTime" },
        { name: "新辅助靶向治疗时间", value: "newAssistTargetedTherapyTime" },
        { name: "PICC维护", value: "piccTime" },
        { name: "末次月经", value: "newMenstrualPeriod" },
        { name: "预产期", value: "predictChildbirth" },
        { name: "绝经时间", value: "lastMenstruation" },
        { name: "辅助生殖手术时间", value: "assistedOperationTime" },
        { name: "促排时间", value: "promotingOvulationTime" },
        { name: "取卵时间", value: "eggRetrievalTime" },
        { name: "移植时间", value: "transplantTime" },
        { name: "移植未孕时间", value: "transplantationPregnancyTime" },
        { name: "试管日期", value: "testTubeDate" },
        { name: "上次经期开始时间", value: "latestMenstrualDate" },
        { name: "冻胚进周时间", value: "frozenEmbryoDate" },
        { name: "本次经期开始时间", value: "nextMenstrualDate" },
        { name: "夜针时间", value: "nightNeedleDate" },
        { name: "看胚胎结果时间", value: "embryoResultDate" },
        { name: "宫腔镜时间", value: "hysteroscopyDate" },
        { name: "妊娠确认时间", value: "confirmPregnancyDate" },
        { name: "妊娠后首次B超时间", value: "firstPregnancyBScanDate" },
        { name: "妊娠后二次B超时间", value: "secondPregnancyBScanDate" }
      ]
    };
  },
  methods: {
    addTime(item) {
      this.editeStatus = false;
      this.dateValue = "";
      this.curEditeItem = "";
      // 编辑
      if (item && item.dataValue) {
        this.dateValue = item.dataValue;
        this.curEditeItem = item;
        this.editeStatus = true;
      }
    },
    //处理时间类型枚举值
    handelDateValue() {
      let time = "";
      this.timeList.map(item => {
        if (item.name == this.name) {
          time = item.value;
        }
      });
      return time;
    },
    submitAddTime() {
      if (!this.dateValue) {
        this.$message.error("请选择" + this.name + "!");
      } else {
        if (!this.editeStatus) {
          this.addPatientDate();
        } else {
          this.upPatientDate();
        }
      }
    },
    // 添加时间
    async addPatientDate() {
      let params = {
        archivesId: sessionStorage.getItem("linkArchivesId"),
        patientId: sessionStorage.getItem("linkPatientId"),
        dateValue: this.dateValue,
        dateName: this.handelDateValue(),
        name: this.name
      };
      let { code, data } = await addPatientDate(params);
      if (code == 0) {
        this.dialogVisible = false;
        this.$message.success("添加成功!");
        this.toUpTime();
      }
    },
    showDelDialog(item) {
      this.curEditeItem = item;
      this.delDialog = true;
      if (this.curEditeItem && this.curEditeItem.axisName) {
        this.tips =
          "当前时间已关联至编链，继续删除会导致已关联的时间轴取消关联，是否继续？";
      }
    },
    onDelTime() {
      this.delPatientDate();
    },
    async delPatientDate() {
      let params = {
        archivesId: sessionStorage.getItem("linkArchivesId"),
        patientId: sessionStorage.getItem("linkPatientId"),
        historyId: this.curEditeItem.id,
        dateName: this.handelDateValue()
      };
      let { code, data } = await delPatientDate(params);
      if (code == 0) {
        this.delDialog = false;
        this.$message.success("删除成功!");
        this.toUpTime();
      }
    },
    // 更新时间
    async upPatientDate() {
      let params = {
        archivesId: sessionStorage.getItem("linkArchivesId"),
        patientId: sessionStorage.getItem("linkPatientId"),
        dateValue: this.dateValue,
        dateName: this.handelDateValue(),
        historyId: this.curEditeItem.id
      };
      let { code, data } = await upPatientDate(params);
      if (code == 0) {
        this.dialogVisible = false;
        this.$message.success("更新成功!");
        this.toUpTime();
      }
    },
    //增删改查后更新患者病例数据
    toUpTime() {
      this.$emit("getUpTime");
    }
  }
};
</script>
<style lang="less" scoped>
.add-time {
  display: inline-block;
}

.add-time,
.chain-edite {
  color: #1a7bfc;
  font-size: 12px;
  cursor: pointer;
}

.chain-edite {
  margin: 0 8px;
}

.chain-checked {
  display: inline-block;
  color: #666;
  font-size: 12px;
  overflow: hidden;
  height: 28px;
}

.del-btn {
  font-size: 12px;
  color: #fb5555;
  cursor: pointer;
}

.tips-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: #faad14;
  color: #fff;
  line-height: 14px;
  text-align: center;
  font-size: 12px;
  border-radius: 50%;
}

.chain-list {
  overflow: hidden;
}

.chain-list-height {
  height: 28px;
}

.add-time-dialog {
  // width: 400px;
  // height: 172px;
  // background: #FFFFFF;
  // box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  // border-radius: 2px;
  // padding: 24px;
  // position: absolute;
  // z-index: 99;
  // right: 45px;
  // top: 5px;

  p {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
    margin-bottom: 20px;
    text-align: center;
  }

  .dialog-footer {
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }
}

.del-dialog {
  width: 300px;
  background: #ffffff;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  padding: 24px 36px;
  position: absolute;
  z-index: 99;
  right: 40px;
  top: -25px;

  .del-con {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    div {
      width: 205px;
    }
  }

  .dialog-footer {
    display: flex;
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}

.chain-item {
  width: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;

  p {
    width: 80px;
    font-size: 12px;
    margin-right: 10px;
  }

  a {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1a7bfc;
    line-height: 28px;
  }

  .edite-record {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 28px;
  }
}

.edite-box {
  display: flex;

  .record {
    width: 77px;
    height: 28px;
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    color: #1a7bfc;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
  }

  .icon-arrow {
    font-weight: bold;
    font-size: 14px;
    margin-left: 5px;
  }
}
</style>
